import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { NoResultsIcon } from "../../assets/icons/MUI/NetworkIcons";
import { colors } from "../../theme/palette";

const NoConnectionsFigure = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        rowGap: "32px",
        gridColumn: "1 / span 3",
        margin: "0 auto",
      }}
    >
      <NoResultsIcon style={{ width: "165px", height: "117px" }} />
      <Typography
        sx={{
          color: colors.Dark600,
          textAlign: "center",
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "22px",
        }}
      >
        {t("components.networkController.noConnection")}
      </Typography>
    </Box>
  );
};

export default NoConnectionsFigure;
